<template>
  <div v-if="!isMobile()">
    <v-hover v-slot="{ hover }">
      <v-card
        class="option-card d-flex justify-center align-center flex-column"
        :style="hover ? 'box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.25);' : ''"
        :key="key"
      >
        <v-toolbar
          width="100%"
          height="35"
          :color="$vuetify.theme.primary || '#39424e'"
          dark
          class="main-bar d-flex justify-center"
          style="color: var(--custom-white-second-color)"
        >
          Opção {{ number }}
        </v-toolbar>

        <div class="d-flex" style="width: 100%">
          <div>
            <v-row class="ma-0">
              <v-col class="header-label">Coberturas</v-col>
              <v-col class="header-label">Capital Segurado</v-col>
              <v-col class="header-label">Custo ao mês</v-col>
              <v-col cols="12" class="my-0">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row v-for="(cover, index) in covers" :key="index" class="ma-0">
              <v-col>
                <v-checkbox
                  v-if="cover.id !== 'MORTE + ADT'"
                  :readonly="cover.valorCapital > 0"
                  :input-value="cover.valorCapital > 0"
                  @click="unmark(cover)"
                  class="ma-0"
                  hide-details
                >
                  <template v-slot:label>
                    <span style="font-size: 12px">{{ cover.name }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-else
                  disabled
                  input-value="true"
                  class="ma-0"
                  hide-details
                >
                  <template v-slot:label>
                    <span style="font-size: 12px">{{ cover.name }}</span>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col class="content-label d-flex justify-center align-center">
                R$
                <v-currency-field
                  type="number"
                  class="ml-2 ma-0 pa-0"
                  :key="update"
                  v-if="cover.id !== 'SAF FAM'"
                  hide-details
                  v-model="cover.valorCapital"
                  @change="recalculate(), getTotalValue()"
                />
                <v-currency-field
                  type="number"
                  class="ml-2 ma-0 pa-0"
                  hide-details
                  v-else
                  readonly
                  v-model="cover.valorCapital"
                  @change="recalculate(), getTotalValue()"
                />
              </v-col>
              <v-col
                class="content-label d-flex justify-center align-center"
                :key="cover.valorCapital"
              >
                {{
                  cover.valorCapital == 0
                    ? "Opcional"
                    : cover.monthly.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        style: "currency",
                        currency: "BRL",
                      })
                }}
              </v-col>
            </v-row>
          </div>

          <div :class="hover ? 'active-price-card' : 'price-card'">
            <div class="d-flex flex-column align-end mx-10">
              <strong class="number-label">Você pagará: </strong>
              <h3
                class="price-label"
                :style="
                  hover
                    ? 'color: var(--custom-white-second-color)'
                    : `color: var(--custom-white-color)`
                "
              >
                {{
                  value.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </h3>
              <span class="number-label">por mês</span>
            </div>

            <div class="d-flex flex-column align-center">
              <div>
                <v-img
                  width="110px"
                  contain
                  src="../../../../assets/logo_icatu.png"
                ></v-img>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-hover>
  </div>

  <div v-else class="mr-6">
    <v-hover v-slot="{ hover }">
      <v-card
        class="option-card d-flex justify-center align-center flex-column"
        :style="hover ? 'box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.25);' : ''"
        :key="key"
      >
        <div v-if="loading">
          <v-progress-circular
            class="ma-3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <div v-if="!loading" style="width: 100%">
          <v-toolbar
            width="100%"
            height="35"
            style="color: var(--custom-white-second-color)"
            :color="$vuetify.theme.primary || '#39424e'"
            dark
            class="main-bar d-flex justify-center"
          >
            Opção {{ number }}
          </v-toolbar>

          <div class="d-flex" style="width: 100%">
            <div class="d-flex flex-column align-center" style="width: 100%">
              <v-row
                v-for="(cover, index) in covers"
                :key="index"
                class="ma-3"
                style="background: #f2f2f2; border-radius: 8px"
              >
                <v-col cols="12">
                  <span class="header-label">Cobertura</span>
                  <v-checkbox
                    v-if="cover.id !== 'MORTE + ADT'"
                    :readonly="cover.valorCapital > 0"
                    :input-value="cover.valorCapital > 0"
                    class="ma-0"
                    @click="unmark(cover)"
                    :label="cover.name"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    v-else
                    disabled
                    input-value="true"
                    class="ma-0"
                    :label="cover.name"
                    hide-details
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <span class="header-label">Capital Segurado</span>
                  R$
                  <v-currency-field
                    type="number"
                    class="ml-2 ma-0 pa-0"
                    :key="update"
                    hide-details
                    v-model="cover.valorCapital"
                    @change="recalculate(), getTotalValue()"
                  />
                </v-col>
                <v-col cols="12">
                  <span class="header-label">Custo ao mês</span>
                  {{
                    cover.valorCapital == 0
                      ? "- Opcional"
                      : cover.monthly.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          style: "currency",
                          currency: "BRL",
                        })
                  }}
                </v-col>
              </v-row>
            </div>
          </div>

          <div :class="hover ? 'active-price-card' : 'price-card'">
            <div class="d-flex flex-column align-end mt-8">
              <strong class="number-label">Você pagará: </strong>
              <h3
                class="price-label"
                :style="
                  hover
                    ? 'color: var(--custom-white-second-color)'
                    : 'color: var(--custom-white-color)'
                "
              >
                {{
                  value.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </h3>
              <span class="number-label mb-8">por mês</span>
            </div>

            <div class="d-flex flex-column align-center mb-8">
              <div>
                <v-img
                  width="110px"
                  contain
                  src="../../../../assets/logo_icatu.png"
                ></v-img>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-hover>
  </div>
</template>

<style scoped>
.option-card {
  background: #ffffff;
  border: 1px solid #00c7ba;
  box-sizing: border-box;
  border-radius: 6px !important;
}

.price-card {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-left: 1px solid #e5e5e5;
}

.active-price-card {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: var(--custom-primary-color);
  border-left: 1px solid #e5e5e5;
}

@media only screen and (max-width: 600px) {
  .price-card {
    border-top: 1px solid #292929 !important;
    border: none !important;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    border-left: 1px solid #e5e5e5;
  }

  .active-price-card {
    width: 100%;
    border-top: 1px solid #292929 !important;
    border: none !important;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background-color: var(--custom-primary-color);
    border-left: 1px solid #e5e5e5;
  }
}

.main-bar {
  background: #39424e;
  border-radius: 6px 6px 0px 0px !important;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.15px;
  text-transform: uppercase;
  color: #ffffff;
}

.header-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
}

.content-label {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: #39424e;
}

.price-label {
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #00c7ba;
}

.number-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
}

.button-label {
  font-weight: bold;
  font-size: 21px;
  line-height: 31px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #00c7ba;
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
const { adjust_death_adt_values } = require("@/services/CoverService");
import { VMoney } from "v-money";

export default {
  name: "Option",

  props: {
    covers: Array,
    number: Number,
    result: Object,
    socio: Object,
  },

  created() {
    this.getTotalValue();
    const styleElement = document.createElement("style");
    styleElement.textContent = `:root { --custom-primary-color: ${
      this.$vuetify.theme.primary || "#00C7BA"
    }; }`;
    document.head.appendChild(styleElement);
  },

  data: () => ({
    value: 0,
    key: false,
    loading: false,
    update: 0,
  }),

  methods: {
    getTotalValue() {
      this.value = 0;

      this.covers.forEach((cover) => {
        if (cover.valorCapital > 0) {
          this.value += cover.monthly;
          this.key = !this.key;
        }
      });
      this.value >= 30 ? this.value : (this.value = 30);
      localStorage.setItem("covers", JSON.stringify(this.covers));
      localStorage.setItem("monthValue", JSON.stringify(this.value));
    },

    unmark(cover) {
      if (cover.valorCapital > 0) {
        cover.valorCapital = 0;
        this.key = !this.key;
      } else if (cover.id == "SAF FAM") {
        cover.valorCapital = 5500;
      } else {
        let filhos = parseInt(this.result.numeroFilhos);
        filhos = filhos == 0 ? 1 : filhos;
        let renda = this.result.valorRenda;
        cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;
      }
      this.recalculate();
      this.getTotalValue();
    },

    async recalculate() {
      try {
        this.loading = true;

        [...this.covers]
          .sort((a, b) => b.order - a.order)
          .forEach((cover) => {
            if (cover.valorCapital > 0) {
              switch (cover.id) {
                case "IPA (S/ MAJ)":
                  if (cover.valorCapital > 5000000) {
                    cover.valorCapital = 5000000;
                  }
                  break;
                case "SAF FAM":
                  if (cover.valorCapital <= 5500) {
                    cover.valorCapital = 5500;
                    this.update++;
                  }
                  break;
                case "DG":
                  if (cover.valorCapital > 1000000) {
                    cover.valorCapital = 1000000;
                  }
                  break;
                case "IED":
                  if (cover.valorCapital > 1000000) {
                    cover.valorCapital = 1000000;
                  }
                  break;
                case "IEA":
                  if (cover.valorCapital > 5000000) {
                    cover.valorCapital = 5000000;
                  }
                  break;
                case "MORTE + ADT":
                  if (cover.valorCapital <= 25000) {
                    cover.valorCapital = 25000;
                  }

                  if (cover.valorCapital > 5000000) {
                    cover.valorCapital = 5000000;
                  }
                  this.update++;
                  adjust_death_adt_values(cover, this.covers);
                  break;
                default:
                  break;
              }
              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
            }
          });

        const cover = this.covers.find((x) => x.id === "MORTE + ADT");

        this.covers.forEach((c) => {
          switch (c.id) {
            case "DG":
              if (c.valorCapital > cover.valorCapital * 2) {
                c.valorCapital = cover.valorCapital * 2;
              }
              break;
            case "IED":
              if (c.valorCapital > cover.valorCapital) {
                c.valorCapital = cover.valorCapital;
              }
              break;
            default:
              break;
          }
        });

        this.key = !this.key;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }

      // let payload = {
      //   codigoProduto: "232455_1_0",
      //   covers: this.covers.filter((x) => x.enabled),
      // };

      // payload.proponente = {
      //   pessoaFisica: this.result.
      // };

      // payload.cpf =
      //   payload.cpf.replace(/\D/g, "");

      // await this.apiService
      //   .post(`api/vida/cotarVida`, payload)
      //   .then((response) => {
      //     this.covers = response;
      //     this.covers.map((cobertura, index) => {
      //       cobertura.monthly = this.covers.covers[index].valorPremio;
      //     });
      //     this.loading = false;
      //   })
      //   .catch(() => {
      //   });
      this.value >= 30 ? this.value : (this.value = 30);
    },

    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
